// WO-33 — Piece 5: the "?" help menu in the top bar (spec §6). Shown on every
// page after login while the onboarding switch is on.
import React from 'react';
import { HelpCircle, ListChecks, Compass, PlayCircle, Mail } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { Button } from '../components/ui/button';
import { useOnboarding } from './OnboardingContext';
import { onboardingCopy, CONTACT_EMAIL } from './copy';
import { fontStyle } from './styles';

export default function HelpMenu() {
  const onb = useOnboarding();
  const c = onboardingCopy.en.help;
  if (!onb.on) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="rounded-xl hover:bg-white/10"
          aria-label={c.button}
          data-onb="help-button"
          data-testid="onboarding-help-button"
        >
          <HelpCircle className="w-5 h-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56" dir="ltr" lang="en" style={fontStyle} data-testid="onboarding-help-menu">
        {onb.eligible && (
          <DropdownMenuItem onClick={onb.openChecklist} className="cursor-pointer" data-testid="onboarding-help-checklist">
            <ListChecks className="w-4 h-4 mr-2" /> {c.gettingStarted}
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={onb.startTour} className="cursor-pointer" data-testid="onboarding-help-tour">
          <Compass className="w-4 h-4 mr-2" /> {c.showMeAround}
        </DropdownMenuItem>
        {onb.demo_video_url && (
          <DropdownMenuItem asChild className="cursor-pointer" data-testid="onboarding-help-demo">
            <a href={onb.demo_video_url} target="_blank" rel="noopener noreferrer">
              <PlayCircle className="w-4 h-4 mr-2" /> {c.demo}
            </a>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem asChild className="cursor-pointer" data-testid="onboarding-help-contact">
          <a href={`mailto:${CONTACT_EMAIL}`}>
            <Mail className="w-4 h-4 mr-2" /> {c.contact}
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
